import React from "react";
import { Row, Col } from "react-bootstrap";
import MutedText from "./mutedText";

/**
 * TitleWMutedRow component displays a row with a title and a muted text.
 * @param {Object} props - Component props
 * @param {string} props.muted - The muted text to be displayed
 * @param {React.ReactNode} props.children - The content of the title
 * @param {React.CSSProperties} props.style - Custom inline styles for the row
 * @returns {JSX.Element} - JSX element representing the TitleWMutedRow component
 */
export default function TitleWMutedRow({ muted, children, style }) {
    return (
        <Row className="mb-3 sneaky-demon-title-muted-row" style={{ ...style }}>
            <Col>
                <h2><strong>{children}</strong></h2>
                <MutedText>{muted}</MutedText>
            </Col>
        </Row>
    );
}
